export default __webpack_public_path__ + "static/media/salesperson.c82be7f2.svg";